import { resolveMediaUrl } from "../../utility/media";
import { IoClose } from "react-icons/io5";
import { useTranslation } from "react-i18next"; // ✅ Added

const ViewMemberDetailsModal = ({ isOpen, onClose, member }) => {
    const { t } = useTranslation(); // ✅ Initialized hook

    if (!isOpen || !member) return null;

    return (
        <div className="staff-modal-overlay">
            <div className="staff-modal" style={{ width: '900px', maxWidth: '95%' }}>
                {/* Header Bar */}
                <div className="staff-modal-header" style={{ background: '#a0adf1', borderBottom: '1px solid #979797' }}>
                    <div className="staff-modal-title" style={{ color: 'white', width: '100%', textAlign: 'center' }}>
                        {t('pageTitles.memberDetails')}
                    </div>
                    <button className="staff-modal-close" onClick={onClose} style={{ color: 'white' }}>
                        <IoClose />
                    </button>
                </div>

                <div className="staff-form-body p-8 bg-white">
                    <div className="grid grid-cols-1 md:grid-cols-5 gap-8 items-start">
                        
                        {/* Left: Photo Section */}
                        <div className="md:col-span-2 flex justify-center">
                            <div className="relative">
                                {member.photoUrl ? (
                                    <img
                                        src={resolveMediaUrl(member.photoUrl)}
                                        alt={member.name}
                                        className="w-64 h-64 object-cover rounded-2xl border-2 border-blue-600 shadow-sm"
                                    />
                                ) : (
                                    <div className="w-64 h-64 flex items-center justify-center border-2 border-blue-600 rounded-2xl bg-gray-50 text-gray-400">
                                        <span className="text-sm">{t('common.noFile')}</span>
                                    </div>
                                )}
                                <p className="mt-4 text-center font-bold text-lg text-gray-800 uppercase tracking-wide">
                                    {member.name}
                                </p>
                            </div>
                        </div>

                        {/* Right: Details Section */}
                        <div className="md:col-span-3 pt-4">
                            <div className="space-y-4">
                                <DetailRow label={t('forms.member.name')} value={member.name} />
                                <DetailRow label={t('forms.member.primaryContact')} value={member.contactPrimary} />
                                <DetailRow label={t('forms.member.secondaryContact')} value={member.contactSecondary} />
                                <DetailRow label={t('forms.member.email')} value={member.email} />
                                <DetailRow label={t('forms.member.wardName')} value={member.wardName} />
                                <DetailRow label={t('forms.member.panNo')} value={member.panNo} />
                                <DetailRow label={t('forms.member.aadhaarNo')} value={member.aadhaarNo} />
                                <DetailRow 
                                    label={t('tables.status')} 
                                    value={member.active ? t('tables.active') : t('tables.inactive')} 
                                />
                            </div>
                        </div>

                    </div>
                </div>

                {/* Footer */}
                <div className="staff-form-footer">
                    <button className="staff-btn-save" onClick={onClose}>
                        {t('common.close')}
                    </button>
                </div>
            </div>
        </div>
    );
};

// Helper component for aligned "Label : Value" rows
const DetailRow = ({ label, value }) => (
    <div className="grid grid-cols-12 gap-2 text-sm">
        <span className="col-span-5 text-right text-gray-700 font-medium">{label}</span>
        <span className="col-span-1 text-center font-bold text-gray-900">:</span>
        <span className="col-span-6 text-left font-bold text-gray-900">
            {value || "—"}
        </span>
    </div>
);

export default ViewMemberDetailsModal;